let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("p0lNF")).then(() => parcelRequire('6Bykx'));